<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Expedição</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                        @click="onAgrupa()"
                        v-b-tooltip
                        title="Agrupar Cargas"
                    ><i class="fa fa-object-group"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('expedicao.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('expedicao.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'doc_fiscal'">
                  </vuetable-filterbar>
                  <spinner
                    v-if="loadingDataExpedir"
                    text-fg-color="#ffffff"
                    message="Carregando..."
                  ></spinner>
                  <spinner
                    v-if="loading"
                    text-fg-color="#000000"
                    message="Carregando..."
                  ></spinner>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                      :key="tableKey"
                      ref="vuetable"
                      :load-on-start="false"
                      :fields="fields"
                      :css="css"
                      :append-params="moreParams"
                      api-url="/api/expedicao"
                      track-by="cargaId"
                      pagination-path="meta"
                      detail-row-component="expedicao-detalhes"
                      no-data-template="Nenhum dado encontrado. Escolha um filtro indicado ou atualize a página."
                      @vuetable:load-error="onError"
                      @vuetable:pagination-data="onPaginationData"
                      @vuetable:loaded="onLoaded"
                      class="table-responsive-sm"
                  >
                    <template slot="transportadora" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.pessoa !== null &&
                          props.rowData.pessoa.pessoaJuridica !== null
                        "
                        >PJ /
                        {{ props.rowData.pessoa.pessoaJuridica.razaoSocial }}
                        CNPJ:
                        {{
                          onFormataCnpj(
                            props.rowData.pessoa.pessoaJuridica.cnpjBase,
                            props.rowData.pessoa.pessoaJuridica.cnpjFilial,
                            props.rowData.pessoa.pessoaJuridica.cnpjDigito
                          ).replace(
                            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                            "$1.$2.$3/$4-$5"
                          )
                        }}
                        IE:
                        {{
                          props.rowData.pessoa.pessoaJuridica.inscricaoEstadual
                        }}</span
                      >
                      <span
                        v-if="
                          props.rowData.pessoa !== null &&
                          props.rowData.pessoa.pessoaFisica !== null
                        "
                        >PF / {{ props.rowData.pessoa.pessoaFisica.nome }} -
                        {{ props.rowData.pessoa.pessoaFisica.cpf }}</span
                      >
                      <span
                        v-if="
                          props.rowData.pessoa !== null &&
                          props.rowData.pessoa.pessoaExterior !== null
                        "
                        >PE / {{ props.rowData.pessoa.pessoaExterior.nome }} -
                        {{ props.rowData.pessoa.pessoaExterior.cd }}</span
                      >
                      <span v-if="props.rowData.pessoa == null"
                        >Sem transportadora vinculada</span
                      >
                    </template>
                    <template slot="meioTranspPri" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.cargaMeioTransp !== null &&
                          props.rowData.cargaMeioTransp.veiculoMotorista !==
                            null &&
                          props.rowData.cargaMeioTransp.veiculoMotorista !==
                            null &&
                          props.rowData.cargaMeioTransp.veiculoMotorista
                            .veiculo !== null &&
                          props.rowData.cargaMeioTransp.veiculoMotorista.veiculo
                            .paramTipoRodado !== null
                        "
                        >{{
                          props.rowData.cargaMeioTransp.veiculoMotorista.veiculo
                            .paramTipoRodado.descr
                        }}
                        -
                        {{
                          formatNumber(
                            props.rowData.cargaMeioTransp.veiculoMotorista
                              .veiculo.paramTipoRodado.capacidadePeso
                          )
                        }}
                        KG
                      </span>
                    </template>
                    <template slot="unidade" slot-scope="props">
                      <span v-if="props.rowData.cargaUnidade !== null">{{
                        props.rowData.cargaUnidade.unidade
                      }}</span>
                    </template>
                    <template slot="dtExpedicao" slot-scope="props">
                      <span v-if="props.rowData.dtExpedicao !== null">{{
                        formatDateSeconds(props.rowData.dtExpedicao)
                      }}</span>
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 3"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                    <template slot="statusProcessoExpedicao" slot-scope="props">
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.statusProcessoExpedicao.valor == 3"
                        >{{ props.rowData.statusProcessoExpedicao.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.statusProcessoExpedicao.valor == 2"
                        >{{ props.rowData.statusProcessoExpedicao.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.statusProcessoExpedicao.valor == 1"
                        >{{ props.rowData.statusProcessoExpedicao.descr }}</span
                      >
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onEdit(props.rowData)"
                          v-if="
                            props.rowData.status.valor != 3 &&
                            props.rowData.statusProcessoExpedicao.valor == 1
                          "
                          v-b-tooltip
                          title="Editar"
                          ><i class="fa fa-truck"></i
                        ></a>
                        <a
                          @click="onCreate(props.rowData.cargaId, 2)"
                          v-b-tooltip
                          title="Escanear volumes"
                          v-if="
                            props.rowData.status.valor != 3 &&
                            props.rowData.statusProcessoExpedicao.valor == 1 &&
                            getPermissionFw('expedicao.escanear.volumes')
                          "
                          ><i class="fa fa-barcode"></i
                        ></a>
                        <a
                          @click="onCreateChecagemCte(props.rowData.cargaId)"
                          v-b-tooltip
                          title="Checar CTes da carga"
                          ><i class="fa fa-barcode"></i
                        ></a>
                        <a
                            @click="onCreateChecagemNfs(props.rowData.cargaId)"
                            v-b-tooltip
                            title="Checar NFs da carga"
                        ><i class="fa fa-barcode"></i
                        ></a>
                        <a
                          @click="
                            onStore(
                              props.rowData.cargaId,
                              props.rowData.cargaMeioTransp,
                              props.rowData.numCarga
                            )
                          "
                          v-if="
                            getPermissionFw('expedicao.store') &&
                            props.rowData.status.valor != 3 &&
                            props.rowData.statusProcessoExpedicao.valor == 1 &&
                            props.rowData.pessoa !== null
                          "
                          v-b-tooltip
                          title="Confirmar Expedição"
                          ><i class="fa fa-check"></i
                        ></a>
                        <a
                          @click="onCancelaMontagemCarga(props.rowData.cargaId)"
                          v-if="
                            props.rowData.status.valor != 3 &&
                            props.rowData.statusProcessoExpedicao.valor == 1
                          "
                          v-b-tooltip
                          title="Cancelar montagem de carga"
                          ><i class="fa fa-times"></i
                        ></a>
                        <a
                          @click="onImprimirRomaneio(props.rowData)"
                          v-if="
                            getPermissionFw('gerenciamentotransporte.imprimir_romaneio') &&
                            props.rowData.tpOperacaoPrincipal == 3 &&
                            props.rowData.statusProcessoExpedicao.valor == 3 &&
                            props.rowData.retira != 1
                          "
                            v-b-tooltip
                            title="Imprimir Romaneio"
                        ><i class="fa fa-print"></i
                        ></a>
                        <a
                            @click="onImprimirRomaneio(props.rowData)"
                            v-if="
                            props.rowData.statusProcessoExpedicao.valor == 3 &&
                            props.rowData.retira == 1
                          "
                            v-b-tooltip
                            title="Imprimir Retira"
                        ><i class="fa fa-print"></i
                        ></a>
                        <a
                            @click="onImprimirRomaneioProvisorio(props.rowData)"
                            v-if="
                            getPermissionFw('gerenciamentotransporte.imprimir_romaneio') &&
                            props.rowData.statusProcessoExpedicao.valor == 1 ||
                            props.rowData.statusProcessoExpedicao.valor == 2 
                          "
                            v-b-tooltip
                            title="Imprimir Romaneio Provisório"
                        ><i class="fa fa-print"></i
                        ></a>
                        <a
                          @click="onImprimirManifesto(props.rowData)"
                          v-if="
                            props.rowData.tpOperacaoPrincipal == 2 &&
                            props.rowData.statusProcessoExpedicao.valor == 3 &&
                            props.rowData.manifesto !== null &&
                            props.rowData.manifesto.status == 6
                          "
                          v-b-tooltip
                          title="Imprimir Manifesto"
                          ><i class="fa fa-print"></i
                        ></a>
                        <a
                          @click="sequenciaExpedicao(props.rowData.cargaId)"
                          v-b-tooltip
                          v-if="getPermissionFw('expedicao.store')"
                          title="Sequenciar entrega"
                          ><i
                            v-if="
                              props.rowData.status.valor != 3 &&
                              props.rowData.statusProcessoExpedicao.valor == 1
                            "
                            class="fa fa-map-o"
                          ></i
                        ></a>
                        <a
                          @click="onGerarDoc(props.rowData)"
                          v-b-tooltip
                          title="Gerar Documento"
                          v-if="
                            getPermissionFw('expedicao.store') &&
                            permiteGerarDoc &&
                            props.rowData.status.valor != 1 &&
                            props.rowData.retira != 1 &&
                            props.rowData.statusProcessoExpedicao.valor == 3 &&
                            props.rowData.statusIntegracoes
                              .statusGeralOpentech == 1 &&
                            (((props.rowData.manifesto == null ||
                              props.rowData.manifesto.status == 14) &&
                              props.rowData.tpOperacaoPrincipal != 3) ||
                              props.rowData.tpOperacaoPrincipal == 3 && props.rowData.interestadual == 1)
                          "
                          ><i class="fa fa-file-text"></i
                        ></a>
                        <a
                          @click="onCompraPedagioAvulso(props.rowData)"
                          v-b-tooltip
                          title="Comprar Pedagio avulso"
                          v-if="
                            getPermissionFw('expedicao.store') &&
                            props.rowData.status.valor != 1 &&
                            props.rowData.retira != 1 &&
                            props.rowData.statusProcessoExpedicao.valor == 3 &&
                            props.rowData.statusIntegracoes.statusTargetPedagio
                              .status.valor == 2
                          "
                          ><i class="fa fa-car"></i
                        ></a>
                        <a
                          @click="onEventoIntegracao(props.rowData, 1)"
                          v-b-tooltip
                          title="Integrar ATM"
                          v-if="showEndorsementIntegrationButton(props.rowData)"
                        ><i class="fa fa-money"></i
                        ></a>
                        <a
                          @click="onEventoIntegracao(props.rowData, 2)"
                          v-b-tooltip
                          title="Integrar Iroute"
                          v-if="showRoutingIntegrationButton(props.rowData)"
                          ><i class="fa fa-map-pin"></i
                        ></a>
                        <a
                          @click="onEventoIntegracao(props.rowData, 3)"
                          v-b-tooltip
                          title="Integrar roteiro target"
                          v-if="showTargetIntegrationButton(props.rowData)"
                          ><i class="fa fa-bullseye"></i
                        ></a>
                        <a
                            @click="onEventoIntegracao(props.rowData, 6)"
                            v-b-tooltip
                            title="Cancelamento do Vale Pedágio"
                            v-if="
                            getPermissionFw('expedicao.store') &&
                            props.rowData.cargaValePedagio != null"
                          ><i class="fa fa-window-close-o"></i
                        ></a>
                        <a
                          @click="onCancelarCargaNstech(props.rowData)"
                          v-b-tooltip
                          v-if="
                            getPermissionFw('expedicao.store') &&
                            props.rowData.integracaoNstech.length > 0 &&
                            (![1, 6].includes(props.rowData.statusExpedicaoNstech))
                          "
                          title="Cancelar carga na NSTech"
                          ><i class="fa fa-times"></i
                        ></a>
                        <a
                          @click="onEstornaCalculo(props.rowData.cargaId)"
                          v-b-tooltip
                          v-if="showEstornaCalculoButton(props.rowData)"
                          title="Estornar calculo"
                          ><i class="fa fa-window-close-o"></i
                        ></a>
                        <a
                          @click="onGeraCiot(props.rowData)"
                          v-b-tooltip
                          title="Integrar Ciot Target"
                          v-if="showCiotIntegrationButton(props.rowData)"
                          ><i class="fa fa-bullseye"></i
                        ></a>
                        <a
                            @click="onCancelaExpedicao(props.rowData)"
                            v-b-tooltip
                            title="Cancelar processo de Expedição"
                            v-if="props.rowData.statusProcessoExpedicao.valor != 1 && props.rowData.statusExpedicaoDespesa != 2"
                        ><i class="fa fa-times-circle"></i
                        ></a>
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          v-if="
                            props.rowData.statusProcessoExpedicao.valor != 1 ||
                            props.rowData.consultaCompleta
                          "
                          ><i class="fa fa-plus"></i
                        ></a>
                        <a
                          @click="onReenviarItrack(props.rowData.cargaId)"
                          v-b-tooltip
                          title="Reenviar Itrack"
                          v-if="showItrackIntegrationButton(props.rowData)"
                          ><i class="fa fa-reply"></i
                        ></a>
                        <a
                          @click="
                            onValidateDefaultCte(
                              props.rowData.cargaId
                            )
                          "
                          v-b-tooltip
                          title="Reenviar CTE"
                          v-if="showDocumentIntegrationButton(props.rowData)"
                          ><i class="fa fa-reply"></i
                        ></a>
                        <a
                          @click="
                            onReenviarItrackMdfe(
                              props.rowData.manifesto.manifestoId
                            )
                          "
                          v-b-tooltip
                          title="Reenviar MDFe Itrack"
                          v-if="
                            getPermissionFw('expedicao.store') &&
                            props.rowData.status.valor == 3
                          "
                          ><i class="fa fa-reply"></i
                        ></a>
                        <a
                          @click="onReenvioTrnDocFis(props.rowData.cargaId)"
                          v-b-tooltip
                          title="Redefinir parceiro das notas fiscais"
                          v-if="
                            getPermissionFw('expedicao.reenvio.pesssoatransp')
                          "
                          ><i class="fa fa-user"></i
                        ></a>
                        <a
                            @click="onDesagrupaCarga(props.rowData.cargaId)"
                            v-b-tooltip
                            title="Desagrupar carga"
                        ><i class="fa fa-object-ungroup"></i
                        ></a>
                        <a
                            @click="onEnviaFreteAvulso(props.rowData)"
                            v-b-tooltip
                            title="Gerar carregamento despesa"
                            v-if="showExpanseIntegrationButton(props.rowData)"
                          ><i class="fa fa-cubes"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                          v-if="filterApplied"
                          ref="paginationInfo"
                          :css="css.pagination"
                          info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                          v-if="filterApplied"
                          ref="pagination"
                          :css="css.pagination"
                          @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ExpedicaoForm ref="expedicaoform" />
      <MontagemCargaForm ref="montagemcargaform" />
      <ChecagemCteCarga ref="checagemctecarga" />
      <ChecagemNfsCarga ref="checagemnfscarga" />
      <ExpedicaoCargaForm ref="expedicaocargaform" />
      <ExpedicaoSequenciaForm ref="expedicaosequenciaform" />
      <ExpedicaoModalPagamentoTarget ref="expedicaomodalpagamentotarget" />
      <ExpedicaoFreteAvulso ref="expedicaofreteavulso" />
    </div>
  </div>
</template>

<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import ExpedicaoFilterBar from "./ExpedicaoFilterBar";
import moment from "moment";
import accounting from "accounting";
import ExpedicaoDetalhes from "./ExpedicaoDetalhes";
import ExpedicaoForm from "./ExpedicaoForm";
import MontagemCargaForm from "./MontagemCargaForm";
import ExpedicaoCargaForm from "./ExpedicaoCargaForm";
import ChecagemCteCarga from "./ChecagemCteCarga";
import ChecagemNfsCarga from "./ChecagemNfsCarga";
import ExpedicaoSequenciaForm from "./ExpedicaoSequenciaForm";
import ExpedicaoModalPagamentoTarget from "./ExpedicaoModalPagamentoTarget";
import ExpedicaoFreteAvulso from "./ExpedicaoFreteAvulso";

Vue.component("expedicao-detalhes", ExpedicaoDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    ExpedicaoForm,
    MontagemCargaForm,
    ExpedicaoCargaForm,
    ExpedicaoSequenciaForm,
    ChecagemCteCarga,
    ChecagemNfsCarga,
    ExpedicaoModalPagamentoTarget,
    ExpedicaoFreteAvulso,
    "vuetable-filterbar": ExpedicaoFilterBar,
  },
  data() {
    return {
      filterApplied: false,
      tableKey: 0,
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      peso_bruto: "",
      checkbox: [],
      permiteGerarDoc: true,
      permiteGerarDespesa: true,
      loading: false,
      isDisabled: false,
      loadingData: false,
      loadingDataExpedir: false,
      showModal: false,
      optionsMeioTransp: [],
      optionsStatusProcessoExpedicao: [],
      optionsTipoCarga: [],
      optionsUnidade: [],
      optionsAjudantes: [],
      optionsTipoNf: [],
      optionsMunicipio: [],
      optionsPessoaParceira: [],
      optionsRegiao: [],
      optionsTpRodado: [],
      optionsVeiculo: [],
      optionsUf: [],
      dados: {},
      form: new Form({
        carga_id: "",
        pesmot_id: "",
        vlr_total_nfs: 0,
        ignora_nfs_canceladas: "",
        vlr_total_peso_liquido: 0,
        vlr_total_peso_bruto: 0,
        vlr_total_volume: 0,
      }),
      formreenviaritrack: new Form({
        carga_id: "",
        manifesto_id: "",
      }),
      helpForm: new Form({
        tp_pagamento: "",
        recordCollection: [],
        carga_id: "",
        manifesto_id: "",
        tipo: "",
        status: "",
        tp_agrupamento: "",
        cargaCollection: [],
      }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "numCarga",
          title: "N Carga",
        },
        {
          name: "__slot:dtExpedicao",
          title: "Dt.Expedição Carga",
        },
        {
          name: "__slot:unidade",
          title: "Unidade",
        },
        {
          name: "__slot:transportadora",
          title: "Transportadora",
        },
        {
          name: "__slot:meioTranspPri",
          title: "Meio de Transp.",
        },
        {
          name: "vlrTotalNfs",
          title: "Vlr. total NF",
          callback: "formatNumber",
        },
        {
          name: "pesoBruto",
          title: "Peso bruto",
          callback: "formatNumber",
        },
        {
          name: "pesoLiquido",
          title: "Peso líquido",
          callback: "formatNumber",
        },
        {
          name: "qtdVolume",
          title: "Qtde. Volumes",
          callback: "formatNumber",
        },
        {
          name: "qtdVolumes",
          title: "Qtde. volumes bip",
          callback: "formatNumber",
        },
        {
          name: "qtdDocs",
          title: "Qtde. documentos",
          callback: "formatNumber",
        },
        {
          name: "qtdNfs",
          title: "Qtde. Nfs",
          callback: "formatNumber",
        },
        {
          name: "obs",
          title: "Obs",
        },
        {
          name: "__slot:statusProcessoExpedicao",
          title: "Processo expedição",
        },
        {
          name: "__slot:status",
          title: "Status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.getLivGeral();
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onReenviarItrack(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.formreenviaritrack.carga_id = carga_id;
      this.formreenviaritrack
        .post("/api/expedicao/reenviaritrack")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
        });
    },
    onValidateDefaultCte(shipmentId) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.carga_id = shipmentId;
      this.helpForm
        .post('/api/expedicao/gerar-documentos/' + shipmentId)
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
        });
    },
    onReenvioTrnDocFis(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.carga_id = carga_id;
      this.helpForm
        .post("/api/expedicao/reenviotrndocfis")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
        });
    },
    onReenviarItrackMdfe(manifesto_id) {
      this.loading = true;
      this.isDisabled = true;
      this.formreenviaritrack.manifesto_id = manifesto_id;
      this.formreenviaritrack
        .post("/api/expedicao/reenviaritrackmdfe")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
        });
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.filterApplied = true;
      this.loadingData = true;

      this.moreParams = {
        observacao: data_filter.observacao,
        dt_emi_ini: data_filter.dt_emi_ini,
        regiao: data_filter.regiao,
        redespacho: data_filter.redespacho,
        dt_emi_fim: data_filter.dt_emi_fim,
        num_carga: data_filter.num_carga,
        consulta_completa: data_filter.consulta_completa,
        unidade: data_filter.unidade.value,
        status_processo_expedicao: data_filter.status_processo_expedicao.value,
        transportadora: data_filter.transportadora.pessoa_id,
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.filterApplied = true;
      this.loadingData = true;
      this.moreParams = {};

      Vue.nextTick(() => {
        if (this.$refs.vuetable) {
          this.$refs.vuetable.selectedTo = [];
          this.$refs.vuetable.resetData();
        }
        if (this.$refs.pagination) {
          this.$refs.pagination.resetData();
        }
      });
      this.loadingData = false;
    },
    onLoaded: function () {
      this.loadingData = false;
    },
    onEdit(data) {
      this.$refs.expedicaoform.onEdit(data);
    },
    onCreate(carga_id, tipo) {
      this.$refs.expedicaocargaform.onCreate(carga_id, tipo);
    },
    onStore(carga_id, cargaMeioTransp, num_carga) {
      const vm = this;
      let motorista = "";
      let pesmot_id = "";

      if (
        cargaMeioTransp != null &&
        cargaMeioTransp.veiculoMotorista != null &&
        cargaMeioTransp.veiculoMotorista.pessoaMotorista != null &&
        cargaMeioTransp.veiculoMotorista.pessoaMotorista.pessoaFisica != null
      ) {
        motorista =
          cargaMeioTransp.veiculoMotorista.pessoaMotorista.pessoaFisica.nome;
        pesmot_id =
          cargaMeioTransp.veiculoMotorista.pessoaMotorista.pesmotId;
      }

      let mensagem = "";
      if (motorista != "") {
        mensagem =
          "Você deseja confirmar a expedição para o motorista " +
          motorista +
          " na carga " +
          num_carga +
          "?";
      } else {
        mensagem =
          "Você deseja confirmar a expedição para a carga " +
          num_carga +
          "? Não há motorista vinculado.";
      }

      const onConfirmUnitWrapper = () => {
        confirmAcao(vm, carga_id);
      };

      const onConfirmUnitWrapperNfsCanceladas = () => {
        confirmAcaoNfsCanceladas(vm, carga_id);
      };

      let confirmAcao = function (vm, carga_id) {
        vm.loading = true;
        vm.isDisabled = true;
        vm.form.carga_id = carga_id;
        vm.form.ignora_nfs_canceladas = 2;
        vm.form.pesmot_id = pesmot_id;
        vm.form
          .post("/api/expedicao/store")
          .then((response) => {
            new ReturnApi(response, vm);
            vm.$parent.onFilterReset();
          })
          .catch((errors) => {
            if(errors.has_nfs_canceladas) {
              vm.loading = false;
              vm.isDisabled = false;
              let obj2 = {
                title: "Você deseja confirmar a expedição com notas canceladas?",
                message: errors.message,
                customConfirmBtnText: "Sim",
                customCloseBtnText: "Não",
                type: "warning",
                useConfirmBtn: true,
                onConfirm: onConfirmUnitWrapperNfsCanceladas,
              };

              vm.$Simplert.open(obj2);

            } else {
              new ReturnApi(errors, vm, true, null, null, false);
              vm.errors_array = "";
              vm.errors_array = [];
              for (const property in errors) {
                if (errors.hasOwnProperty(property)) {
                  if (typeof errors[property] === "object") {
                    errors[property].forEach((obj) => {
                      vm.errors_array.push({
                        erro: obj,
                      });
                    });
                  }
                }
              }
            }
          });
      };


      let confirmAcaoNfsCanceladas = function (vm, carga_id) {
        vm.loading = true;
        vm.isDisabled = true;
        vm.form.carga_id = carga_id;
        vm.form.ignora_nfs_canceladas = 1;
        vm.form.pesmot_id = pesmot_id;
        vm.form
            .post("/api/expedicao/store")
            .then((response) => {
              new ReturnApi(response, vm);
              vm.$parent.onFilterReset();
            })
            .catch((errors) => {
                new ReturnApi(errors, vm, true, null, null, false);
                vm.errors_array = "";
                vm.errors_array = [];
                for (var property in errors) {
                  if (errors.hasOwnProperty(property)) {
                    if (typeof errors[property] === "object") {
                      errors[property].forEach((obj) => {
                        vm.errors_array.push({
                          erro: obj,
                        });
                      });
                    }
                  }
                }
            });
      };

      let obj = {
        title: "Confirmar Expedição ?",
        message: mensagem,
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "info",
        useConfirmBtn: true,
        onConfirm: onConfirmUnitWrapper,
      };

      this.$Simplert.open(obj);
    },
    onCreateChecagemCte(cargaId) {
      this.$refs.checagemctecarga.onCreate(cargaId);
    },
    onCreateChecagemNfs(cargaId) {
      this.$refs.checagemnfscarga.onCreate(cargaId);
    },
    onImprimirRomaneio(data) {
      this.isDisabled = true;
      this.loadingData = true;
      this.helpForm.carga_id = data.cargaId;
      this.helpForm
        .post("/api/gerenciamentotransporte/romaneio/imprimir")
        .then((response) => {
          new ReturnApi(response, this, true, false, false, false);
          this.loadingData = false;
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.loadingData = false;
        });
    },
    onImprimirRomaneioProvisorio(data) {
      this.isDisabled = true;
      this.loadingData = true;
      this.helpForm.carga_id = data.cargaId;
      this.helpForm
        .post("/api/gerenciamentotransporte/romaneio-provisorio/imprimir")
        .then((response) => {
          new ReturnApi(response, this, true, false, false, false);
          this.loadingData = false;
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.loadingData = false;
        });
    },
    onImprimirManifesto(data) {
      this.helpForm.manifesto_id = data.manifesto.manifestoId;
      this.helpForm
        .post("/api/mdfe/imprimir")
        .then((response) => {
          new ReturnApi(response, this, true, false, false, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onCancelaMontagemCarga(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.helpForm.carga_id = carga_id;
      this.helpForm
        .patch("/api/montagemcarga/cancelar")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/expedicao/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.meio_transp.forEach((obj) => {
            if (obj.embarcacao_id != null) {
              this.optionsMeioTransp.push({
                label:
                  obj.embarcacao.nome +
                  " - " +
                  obj.embarcacao.param_tipo_embarcacao.descr,
                value: obj.meiotransp_id,
              });
            } else if (obj.veiculo_id != null) {
              if(obj.veiculo.param_tipo_rodado) {

                this.optionsMeioTransp.push({
                  label:
                      obj.veiculo.param_tipo_rodado.descr +
                      " - " +
                      this.formatNumber(
                          obj.veiculo.param_tipo_rodado.capacidade_peso
                      ) +
                      " KG",
                  value: obj.meiotransp_id,
                  tp_rodado: obj.veiculo.param_tipo_rodado.tp_rodado,
                });
              }
            }
          });
          response.veiculo.forEach((obj) => {
            this.meio_transporte = "";
            if (obj.meio_transporte !== null) {
              this.meio_transporte = obj.meio_transporte.meiotransp_id;
            }
            this.optionsVeiculo.push({
              label: obj.placa,
              value: obj.veiculo_id,
              veiculo_id: obj.veiculo_id,
              tp_rodado: obj.param_tipo_rodado ? obj.param_tipo_rodado.tp_rodado : '',
              meiotransp_id: this.meio_transporte,
              veiculo_motorista: obj.veiculo_motorista,
              ultima_situacao: obj.ultima_situacao,
              pessoa_id_agenciador: obj.pessoa_id_agenciador,
            });
          });
          response.tp_rodado.forEach((obj) => {
            this.optionsTpRodado.push({
              label: obj.descr,
              value: obj.partiprod_id,
              tp_rodado: obj.tp_rodado,
            });
          });
          response.pessoa_parceira.forEach((obj) => {
            this.optionsPessoaParceira.push({
              label: obj.descr,
              value: obj.pespar_id,
            });
          });
          response.regiao.forEach((obj) => {
            this.optionsRegiao.push({
              label: obj.cd+' - '+obj.descr,
              value: obj.regiao_id,
            });
          });
          response.unidade.forEach((obj) => {
            this.optionsUnidade.push({
              label: obj.descr,
              value: obj.unidade_id,
            });
          });
          response.ajudante.forEach((obj) => {
            this.optionsAjudantes.push({
              label: obj.nome,
              value: obj.pessoa_id,
              pessoa_id: obj.pessoa_id,
              status: 1
            })
          })
          response.status_processo_expedicao.forEach((obj) => {
            this.optionsStatusProcessoExpedicao.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          console.log('Erro aqui', errors);
          new ReturnApi(errors, this);
        });
    },
    onAgrupa() {
      this.helpForm.cargaCollection = [];
      this.$refs.vuetable.selectedTo.forEach((obj) => {
        this.helpForm.cargaCollection.push(obj);
      });
      const cargas = this.helpForm.cargaCollection;
      const vm = this;
      vm.helpForm.tp_agrupamento = 1;
      vm.helpForm
          .post("/api/expedicao/agrupar")
          .then((response) => {
            new ReturnApi(response, vm, true, null, null, false);
          })
          .catch((errors) => {
            if (errors.tp_message == 'error') {
              new ReturnApi(errors, vm, false, false, false, false);
            } else if (errors.tp_message == 'success') {
              new ReturnApi(errors, vm, false, false, true, false);
            } else {
              var message = errors.message;
              let helpForm = this.helpForm;

              const onConfirmUnitWrapper = () => {
                confirmDesassociarFn(vm);
              };

              let confirmDesassociarFn = function (vm) {
                vm.loading = true;
                vm.helpForm.tp_agrupamento = 2;
                vm.helpForm
                    .post("/api/expedicao/agrupar")
                    .then((response) => {
                      new ReturnApi(response, vm,true, false, true, false);
                      // this.onFilterReset();
                    })
                    .catch((errors) => {
                      new ReturnApi(errors, vm);
                    });
              };

              let obj = {
                title: "Atenção!",
                message: message,
                customConfirmBtnText: "Sim",
                customCloseBtnText: "Não",
                type: "info",
                useConfirmBtn: true,
                onConfirm: onConfirmUnitWrapper,
              };

              this.$Simplert.open(obj);
            }
          });
    },
    onDesagrupaCarga(data) {
      this.helpForm.carga_id = data;
      this.helpForm
          .post("/api/expedicao/desagrupar")
          .then((response) => {
            new ReturnApi(response, this,true, false, true, false);
          })
          .catch((errors) => {
            new ReturnApi(errors, this, true, null, null, false);
          });
    },
    onGerarDoc(data) {
      this.helpForm.carga_id = data.cargaId;
      this.helpForm
        .post("/api/expedicao/mdferomaneio")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          this.permiteGerarDoc = false;
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.permiteGerarDoc = false;
        });
    },
    onEstornaCalculo(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.carga_id = carga_id;
      this.form
        .post("/api/expedicao/calculo/estornar")
        .then((response) => {
          new ReturnApi(response, this, true, false, false, false);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, false, false, false);
        });
    },
    onCancelarCargaNstech(rowData) {
      if (rowData.statusProcessoExpedicao.valor != 3) {
        this.$Simplert.open({
          title: "Atenção",
          message: "Processo de expedição em andamento, por favor aguarde para cancelar.",
          type: "warning",
        });
        return;
      }
      this.loading = true;
      this.isDisabled = true;
      this.helpForm
        .delete('/api/nstech/cancelar-carga/' + rowData.cargaId)
        .then((response) => {
          new ReturnApi(response, this, true, false, false, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, false, false, false);
        });
    },
    onGeraCiot(data) {
      if (data.cargaRota.cargaRotaPedagio.length > 0) {
        this.$refs.expedicaomodalpagamentotarget.onCreate(data, "geraciot");
      } else {
        this.helpForm.carga_id = data.cargaId;
        this.helpForm.tp_pagamento = 0;
        this.helpForm
          .post("/api/expedicao/geraciot")
          .then((response) => {
            new ReturnApi(response, this, true, false, false);
            this.$refs.vuetable.reload();
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    onCompraPedagioAvulso(data) {
      this.$refs.expedicaomodalpagamentotarget.onCreate(data, "pedagioavulso");
    },
    onEnviaFreteAvulso(data) {
      var avulso = false;
      if (data.pessoa.pessoaTranspCalculo.length > 0) {
        data.pessoa.pessoaTranspCalculo.forEach((obj) => {
          if (obj.tpCalc === 8 && data.tpOperacaoPrincipal == obj.tpOperacao && obj.status == 1) {
            avulso = true;
          }
        });
      }
      if (avulso === true) {
        this.$refs.expedicaofreteavulso.onCreate(data);
      } else {
        this.onEventoIntegracao(data, 4);
      }
    },
    onCancelaExpedicao(data) {
      this.helpForm.carga_id = data.cargaId;
      this.helpForm
          .post("/api/expedicao/cancelar")
          .then((response) => {
            new ReturnApi(response, this, true, false, false, false);
            this.onFilterReset();
          })
          .catch((errors) => {
            new ReturnApi(errors, this, true, false, false, false);
            this.onFilterReset();
          });
    },
    onEventoIntegracao(data, tipo) {
      this.helpForm.carga_id = data.cargaId;
      this.permiteGerarDespesa = false;
      this.helpForm.tipo = tipo;
      this.helpForm
          .post("/api/expedicao/integracao/manual")
          .then((response) => {
            new ReturnApi(response, this, true, false, false);
            this.permiteGerarDespesa = false;
            this.onFilterReset();
          })
          .catch((errors) => {
            new ReturnApi(errors, this, true, false, false, false);
            this.permiteGerarDespesa = false;
            this.onFilterReset();
          });
    },
    sequenciaExpedicao(carga_id) {
      this.$refs.expedicaosequenciaform.getData(carga_id);
      this.$refs.expedicaosequenciaform.onView();
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      let cnpj_formatado;
      let pad = "00000000";
      cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      pad = "0000";
       cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      pad = "00";
      cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.cargaId);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "DD MM YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    formatDateSeconds(value, fmt = "D/MM/YYYY HH:mm:ss") {
      return value == null
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm:ss").format(fmt);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    showDocumentIntegrationButton(shipment) {
      return this.getPermissionFw('expedicao.store')
      && shipment.statusIntegracoes.shouldReintegrateDocument
    },
    showCiotIntegrationButton(shipment) {
      return (this.getPermissionFw('expedicao.store') &&
        shipment.statusProcessoExpedicao.valor == 2 &&
        shipment.statusIntegracoes.statusCarregamentoDespesa.status.valor == 1 &&
        shipment.statusIntegracoes.statusIroute.valor == 3 &&
        shipment.statusIntegracoes.statusTargetRoteiro.status.valor == 1 &&
        shipment.statusIntegracoes.statusTargetCiot.status.valor != 1);
    },
    showEstornaCalculoButton(shipment) {
      return this.getPermissionFw('expedicao.calculo.estornar') &&
        shipment.statusProcessoExpedicao.valor != 1 &&
        (shipment.statusIntegracoes.statusCarregamentoDespesa.status.valor == 1 || shipment.statusExpedicaoDespesa == 3) &&
        (shipment.cargaCiot == null &&
          (shipment.status.valor == 3 || shipment.status.valor == 6)) ||
        (shipment.cargaCiot != null &&
          shipment.cargaCiot.statusCiot == 2 &&
          (shipment.status.valor == 3 || shipment.status.valor == 6));
    },
    showExpanseIntegrationButton(shipment) {
      return this.getPermissionFw('expedicao.store') &&
        this.permiteGerarDespesa && 
        ((!shipment.statusIntegracoes.ishybridModule && shipment.statusProcessoExpedicao.valor != 1 &&
        shipment.statusIntegracoes.statusCarregamentoDespesa.status.valor == 2 &&
        shipment.statusIntegracoes.statusIroute.valor == 3 &&
        shipment.statusIntegracoes.statusTargetRoteiro.status.valor == 1)
        || shipment.statusIntegracoes.shouldReintegrateExpanse);
    },
    showTargetIntegrationButton(shipment) {
      return this.getPermissionFw('expedicao.store') &&
        shipment.statusProcessoExpedicao.valor != 1 &&
        ((shipment.statusIntegracoes.statusIroute.valor == 3 &&
        shipment.statusIntegracoes.statusTargetRoteiro.status.valor == 2)
        || shipment.statusIntegracoes.shouldReintegrateTarget);
    },
    showEndorsementIntegrationButton(shipment) {
      return this.getPermissionFw('expedicao.store') 
      && ((shipment.statusProcessoExpedicao.valor != 1 
        && shipment.statusIntegracoes.statusGeralAverbacao == 2 
        && shipment.retira != 1) 
      || shipment.statusIntegracoes.shouldReintegrateEndorsement);
    },
    showItrackIntegrationButton(shipment) {
      return this.getPermissionFw('expedicao.store') &&
        (shipment.status.valor == 3 || shipment.statusIntegracoes.shouldReintegrateItrack);
    },
    showRoutingIntegrationButton(shipment) {
      return this.getPermissionFw('expedicao.store') &&
        ((shipment.statusProcessoExpedicao.valor != 1 &&
          shipment.statusIntegracoes.statusGeralAverbacao == 1 &&
          shipment.statusIntegracoes.statusIroute.valor != 3)
          || shipment.statusIntegracoes.shouldReintegrateRouting);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
  },
};
</script>
